/**
 * A `?next=` value is honoured only if it is a same-origin path of this site: one leading slash, no scheme,
 * no backslash, no control characters.
 */
export function safeNextPath(next: string | null | undefined): string | null {
  if (!next || next.length > 200 || !/^\/(?!\/)[A-Za-z0-9\-._~/%?=&]*$/.test(next)) return null;
  return next;
}
